import config from 'config';
export default {
    methods: {
        /*
         * A Função img(x,y) retorna a URL real da imagem baseado nos dados passados.a1
         * Parâmetros:
         * img: é o nome da imagem, sem nenhum caminho adicional. Apenas o nome do arquivo.
         * raizConteudo: Este valor você pode definir fixo na tela que está trabalhando, ele sim aponta para a pasta
         * correta no servidor e vai te trazer a imagem.
         */
        img(img, raizConteudo) {
            if (!raizConteudo) raizConteudo = '';
            var url = config.app.imgCDN + "app-experience/" + raizConteudo + "/" + img;
            return url;
        },
        formatarData(data) {
            if(!data) return 'N/D';
            const format = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
            return new Date(data).toLocaleDateString('pt-BR',format);
        },
        formatarData2(data) {
            if(!data) return 'N/D';
            const format = {year: 'numeric', month: 'numeric', day: 'numeric'};
            return new Date(data).toLocaleDateString('pt-BR',format);
        },
        formatarHora(hora) {
            if(!hora) return 'N/D';
            hora = hora.split(':');
            hora = `${hora[0]}:${hora[1]}`
            return hora;
        },
        statusAgendaProtetico(status) {
           const colors = {
            'aguardando': '#ED6B00',
            'producao': '#00aeef',
            'finalizado': '#00ce5d',
            'cancelado': '#a8a8a8',
            }
            return colors[status];
        }
    }
};